import {
  Alert,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Stack,
  Typography
} from '@mui/material';
import { GridFooter, GridFooterContainer, GridToolbarExport } from '@mui/x-data-grid-pro';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import {
  useGetEligiblePatientDataMutation,
  useUpdatePatientTrailStatusMutation,
  useUpdatePreScreenStatusMutation
} from 'src/services/eligiblePatients';
import { setMessage } from 'src/store/Message';
import { useUser } from 'src/components/hooks/useUser';
import { PopupComponent } from 'src/components/common/PopupComponent';
import CheckIcon from '@mui/icons-material/Check';

import CloseIcon from '@mui/icons-material/Close';
import { hideLoader, showLoader } from 'src/store/Loader';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import moment from 'moment';
import { useAppDispatch } from 'src/store';
import React, { useState, useEffect } from 'react';
import { DataTable } from '@pihealth/common-ui-library';
import Loader from 'src/components/common/Loader';
import { useAppSelector } from 'src/store/hooks';

// for Custom buttons at bottom in Data Grid
const CustomFooterButtons = (handleClickOpen: any, preScrnBtnEnable: boolean, handleClickPreScreen: any) => {
  const { checkPermission } = usePermissionWrapper();
  return (
    <GridFooterContainer>
      <Box sx={{ p: 1, display: 'flex', columnGap: 1 }}>
        {checkPermission('prescreen_eligible_patients') && (
          <Button variant="outlined" onClick={handleClickOpen} disabled={preScrnBtnEnable}>
            Prescreen
          </Button>
        )}
        {checkPermission('fail_prescreen_patients') && (
          <Button
            variant="outlined"
            onClick={handleClickPreScreen}
            disabled={preScrnBtnEnable}
            sx={{ minWidth: '150px' }}
          >
            Prescreen Fail
          </Button>
        )}
      </Box>
      <GridFooter />
    </GridFooterContainer>
  );
};

export default function EligiblePatient(props: any) {
  const dispatch = useAppDispatch();
  const { user } = useUser();
  // for Datagrid static columns
  const [rows, setRows] = useState([]);

  const [getEligiblePatientsData, { data, isError, error, isLoading }] = useGetEligiblePatientDataMutation();
  const isLoaderLoading = useAppSelector(state => state.loader.isLoading);

  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [preScrnBtnEnable, setPreScrnBtnEnable] = useState<boolean>(true);
  const [disableconfirm, setDisableConfirm] = useState<boolean>(true);
  const [selectionModel, setSelectionModel] = useState([]);
  const [selectedIds, setSelectedIds] = useState<any>([]);
  const [parentIds, setSelectedParentIds] = useState<any>([]);
  const [noOfRows, setNoOfRows] = useState<any>([]);
  const [eligibaleTrialIds, setEligibaleTrialIds] = useState<any>([]);
  const [trial, setTrial] = React.useState('');
  const [selectedPreScreenFailPatients, setSelectedPreScreenFailPatients] = useState<any>([]);
  const [failPatients, setFailPatients] = useState<any>([]);
  const [preScreenSubmit, setPreScreenSubmit] = useState<boolean>(false);
  const { userPreferedDateFormat, preferedDateFormat } = usePreferedDateFormat();

  const [
    updatePatientStatus,
    {
      isError: updatePatientStatusIsError,
      error: updatePatientStatusError,
      isSuccess: updatePatientStatusSuccess,
      isLoading: updatePatientStatusLoading
    }
  ] = useUpdatePatientTrailStatusMutation();

  const [
    updatePatientPreScreenStatus,
    {
      isError: updatePatientPreScreenStatusIsError,
      error: updatePatientPreScreenStatusError,
      isSuccess: updatePatientPreScreenStatusSuccess,
      isLoading: updatePatientPreScreenStatusLoading
    }
  ] = useUpdatePreScreenStatusMutation();

  // for Open Dialog 1
  const [open, setOpen] = React.useState(false);
  const [preScreen, setPreScreen] = React.useState(false);

  const handleClickOpen = () => {
    if (noOfRows.length > 10) {
      dispatch(setMessage({ msgDetails: 'Maximum 10 patients are allowed.', severity: 'error' }));
    } else {
      setTrial('');
      const failTrials = failPatients.map((f: any) => f.trial_id);
      const finalTrials = eligibaleTrialIds.filter((v: string) => failTrials.indexOf(v) === -1);
      if (failTrials.length > 0) {
        setEligibaleTrialIds(finalTrials);
        setFailPatients([]);
      }
      setOpen(true);
    }
  };

  const handleClickPreScreen = () => {
    if (noOfRows.length > 10) {
      dispatch(setMessage({ msgDetails: 'Maximum 10 patients are allowed.', severity: 'error' }));
    } else {
      let trials = 0;
      noOfRows.forEach((patient: any) => (trials = trials + patient.eligible_trials.length));
      if (trials > selectedPreScreenFailPatients.length) {
        let preScreenMultipleSelected: any = [];
        preScreenMultipleSelected = selectedPreScreenFailPatients;
        noOfRows.map((row: any) => {
          if (row.eligible_trials.length > 1) {
            row.eligible_trials.forEach((patient: any) => {
              if (preScreenMultipleSelected.filter((selected: any) => selected.trial_id === patient).length === 0) {
                preScreenMultipleSelected.push({
                  parent_id: row.parent_id,
                  patient_id: row.Core_FICS_patient_identifier,
                  trial_id: patient,
                  comments: row.prescreen_fail_comments
                });
              }
            });
          }
          if (preScreenMultipleSelected.filter((patient: any) => patient.parent_id === row.parent_id).length === 0) {
            preScreenMultipleSelected.push({
              parent_id: row.parent_id,
              patient_id: row.Core_FICS_patient_identifier,
              trial_id: row.eligible_trials[0],
              comments: row.prescreen_fail_comments
            });
          }
        });
        setSelectedPreScreenFailPatients([...preScreenMultipleSelected]);
      }
      setPreScreen(true);
    }
  };

  const handleClose = async () => {
    setOpen(false);
    setDisableConfirm(true);
  };

  const handleClosePreScreen = async () => {
    setPreScreen(false);
    setSelectedPreScreenFailPatients([]);
  };

  const handlePreScreenSubmit = async () => {
    const preScreenFailData: any = [];
    let flag = false;
    for (const i of selectedPreScreenFailPatients) {
      if (i.comments === null || i.comments === '' || !i.comments.length) {
        flag = true;
        break;
      }
      preScreenFailData.push({
        parent_id: i.parent_id,
        trial_id: i.trial_id,
        comments: i.comments
      });
    }

    if (flag) {
      dispatch(
        setMessage({
          msgDetails: 'Missing mandatory information',
          severity: 'error'
        })
      );
    } else {
      setFailPatients(preScreenFailData);
      setPreScreenSubmit(true);
    }
  };

  const finalPreScreenSubmit = async () => {
    const preScreenFailData = {
      patient_update_details: failPatients,
      patient_trial_status: 'Prescreen Failure',
      updated_by: user
    };

    await updatePatientPreScreenStatus({ data: preScreenFailData });
    handleClosePreScreen();
    setPreScreenSubmit(false);
    setSelectedPreScreenFailPatients([]);
  };

  const handleConfirm = async () => {
    const updateReqObject = {
      parent_id: parentIds,
      eligible_trials: trial,
      patient_trial_status: 'In Trial'
    };
    await updatePatientStatus({ data: updateReqObject, user });
  };

  const updateComment = (value: any, index: any) => {
    const patientComments = selectedPreScreenFailPatients.map((patient: any, i: number) => {
      if (index === i) {
        return { ...patient, comments: value };
      } else {
        return patient;
      }
    });
    setSelectedPreScreenFailPatients(patientComments);
  };
  const [filterObject, setFilterObject] = useState<any>();

  useEffect(() => {
    if (updatePatientPreScreenStatusSuccess) {
      dispatch(
        setMessage({
          msgDetails: `${selectedPreScreenFailPatients.length} Subjects Prescreen Failed.`,
          severity: 'success'
        })
      );
      getEligiblePatientsData({
        data: filterObject,
        status: 'Prescreen Eligible',
        from: pageNumber * pageSize,
        size: pageSize
      });
      setSelectionModel([]);
    }
  }, [updatePatientPreScreenStatusSuccess]);

  useEffect(() => {
    if (pageSize === 10 || pageSize === 20 || pageSize === 30) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getEligiblePatientsData({
          data: filterObject,
          status: 'Prescreen Eligible',
          from: 0,
          size: pageSize
        });
      } else {
        getEligiblePatientsData({
          data: filterObject,
          status: 'Prescreen Eligible',
          from: pageNumber * pageSize,
          size: pageSize
        });
      }
    }
  }, [pageNumber, pageSize, filterObject]);

  useEffect(() => {
    if (updatePatientStatusSuccess) {
      dispatch(
        setMessage({
          msgDetails: `${selectedIds.length} Subject(s) successfully added to prescreening.`,
          severity: 'success'
        })
      );
      const tempArr = props.tabpanelData.map((tab: any) => {
        return {
          ...tab,
          badgeCount: selectedIds.length
        };
      });
      props.setTabpanelData(tempArr);
      setOpen(false);
      getEligiblePatientsData({
        data: filterObject,
        status: 'Prescreen Eligible',
        from: pageNumber * pageSize,
        size: pageSize
      });
      setPreScrnBtnEnable(true);
    }
  }, [updatePatientStatusSuccess]);

  //for select trial inside dialog
  const handleChange = (event: SelectChangeEvent) => {
    setTrial(event.target.value);
    setDisableConfirm(false);
  };

  // checkbox selection
  const onSelectionModelChange = (ids: any) => {
    if (ids.length > 10) {
      dispatch(setMessage({ msgDetails: 'Maximum 10 patients are allowed.', severity: 'error' }));
      setPreScrnBtnEnable(true);
    } else {
      setSelectionModel(ids);
      setDisableConfirm(true);
      const selectedIds = new Set(ids);
      const patientIds: any = rows
        .filter((row: any) => selectedIds.has(row.id))
        .map((elem: any) => elem.Core_FICS_patient_identifier);
      const parentIds: any = rows.filter((row: any) => selectedIds.has(row.id)).map((elem: any) => elem.id);
      const preScreenMultipleSelected: any = [];
      rows
        .filter((row: any) => selectedIds.has(row.id))
        .forEach((elem: any) => {
          if (elem.eligible_trials.length > 1) {
            elem.eligible_trials.forEach((patient: any) => {
              preScreenMultipleSelected.push({
                parent_id: elem.parent_id,
                patient_id: elem.Core_FICS_patient_identifier,
                trial_id: patient,
                comments: elem.prescreen_fail_comments
              });
            });
          } else {
            preScreenMultipleSelected.push({
              parent_id: elem.parent_id,
              patient_id: elem.Core_FICS_patient_identifier,
              trial_id: elem.eligible_trials[0],
              comments: elem.prescreen_fail_comments
            });
          }
        });

      setSelectedPreScreenFailPatients([...preScreenMultipleSelected]);

      const rowSelected = rows.filter((row: any) => selectedIds.has(row.id));

      if (rowSelected.length > 0) {
        setPreScrnBtnEnable(false);
      } else {
        setPreScrnBtnEnable(true);
      }

      setSelectedParentIds(parentIds);
      setSelectedIds(patientIds);
      //common eligible trials logic
      const eligibleTrials = rowSelected.map((eid: any) => eid.eligible_trials);
      const intersection = (arr1: any, arr2: any) => {
        const res = [];
        for (const i of arr1) {
          if (!arr2.includes(i)) {
            continue;
          }
          res.push(i);
        }
        return res;
      };
      const intersectMany = (...arrs: any) => {
        let res = arrs[0].length > 0 ? arrs[0][0].slice() : [`${trial}`];
        for (let i = 1; i < arrs[0].length; i++) {
          res = intersection(res, arrs[0][i]);
        }
        return res;
      };
      const commonEligibleTrials = intersectMany(eligibleTrials);
      setEligibaleTrialIds(commonEligibleTrials);
      setNoOfRows(rowSelected);
    }
  };

  const [columns, setColumns] = useState([]);
  //Trial Eligible patient datas
  useEffect(() => {
    if (data) {
      setRowsCount(data.record_count);
      const tempColumns: any = [
        {
          field: 'Core_FICS_patient_identifier',
          headerName: 'Core FICS Patient Identifier',
          minWidth: 90,
          flex: 1
        },
        {
          field: 'sex',
          headerName: 'Sex',
          width: 80,
          flex: 1
        },
        {
          field: 'date_of_birth',
          headerName: 'Date of Birth',
          minWidth: 100,
          flex: 1,
          type: 'date'
        },
        {
          field: 'eligible_trials',
          headerName: 'Eligible Trials',
          width: 150,
          renderCell: (params: any) => {
            return (
              <>
                {params.row.eligible_trials.length > 1 ? (
                  <Stack direction="column" spacing={0} className="fakeRowColSpan withLeftBorder">
                    {params.row.eligible_trials.map((trial: any) => (
                      <Box key={`eligible_trials_${trial}`} className="tableCell">
                        {trial}
                      </Box>
                    ))}
                  </Stack>
                ) : (
                  params.row.eligible_trials[0]
                )}
              </>
            );
          },
          valueGetter: (params: any) => {
            return params.row.eligible_trials.join();
          }
        }
      ];
      let maxLenth = 0;
      data?.selected_data.map((criteriaList: any) => {
        criteriaList.criteria.map((criteriaObjs: any) => {
          if (typeof criteriaObjs == 'object') {
            const criteriaObj = Object.values(criteriaObjs);
            criteriaObj.forEach((item: any) => {
              item.forEach((lists: any) => {
                const nestedList: any = Object.values(lists);
                let totalLength = 0;
                for (const i of nestedList) {
                  totalLength += i.length;
                }
                if (maxLenth < totalLength) {
                  maxLenth = totalLength;
                }
              });
            });
          }
        });
      });
      if (maxLenth >= 0) {
        const criteriaColumns: any = [];
        for (let i = 0; i < maxLenth; i++) {
          criteriaColumns.push({
            field: `criteria_${Number(i + 1)}`,
            headerName: `Criteria ${Number(i + 1)}`,
            width: 90,
            renderCell: (params: any) => {
              const multiStudyData: any = Object.values(
                Object.values(params.row.criteria.map((i: any) => (Object.values(i)[0] as any).flat())).map(
                  (item: any) => item[0]
                )
              );
              const toolTipDataMultiStudy = multiStudyData.map((item: any) => Object.values(item).flat());
              return (
                <>
                  {params.row.criteria.length > 1 ? (
                    <Stack direction="column" spacing={0} className="fakeRowColSpan">
                      {toolTipDataMultiStudy.map((item: any) => {
                        return item[i] ? (
                          <Box
                            className="tableCell alignCenter"
                            key={`${params.row.eligible_trials[i]}-${item[i].value}`}
                          >
                            <Tooltip
                              title={`${item[i].field} ${item[i].operator.replaceAll('_', ' ')} ${
                                item[i].type === 'DATE' ? preferedDateFormat(item[i].value) : item[i].value
                              }`}
                              placement="top"
                              className="smallfontTooltip"
                            >
                              <CheckIcon color="primary" />
                            </Tooltip>
                          </Box>
                        ) : (
                          <Box className="tableCell alignCenter emptyGrey" />
                        );
                      })}
                    </Stack>
                  ) : (
                    <>
                      {toolTipDataMultiStudy.map((item: any) => {
                        return item[i] ? (
                          <Stack direction="column" spacing={0} className="fakeRowColSpan">
                            <Box className="tableCell alignCenter">
                              <Tooltip
                                title={`${item[i].field} ${item[i].operator.replaceAll('_', ' ')} ${
                                  item[i].type === 'DATE' ? preferedDateFormat(item[i].value) : item[i].value
                                }`}
                                placement="top"
                                className="smallfontTooltip"
                              >
                                <CheckIcon color="primary" />
                              </Tooltip>
                            </Box>
                          </Stack>
                        ) : (
                          <Box className="tableCell alignCenter emptyGrey" />
                        );
                      })}
                    </>
                  )}
                </>
              );
            },
            valueGetter: (params: any) => {
              const multiStudyData: any = Object.values(
                Object.values(params.row.criteria.map((i: any) => (Object.values(i)[0] as any).flat())).map(
                  (item: any) => item[0]
                )
              );
              const toolTipDataMultiStudy = multiStudyData?.map((item: any) => Object.values(item).flat());
              const temp = toolTipDataMultiStudy
                .map((item: any) =>
                  item[i] ? `${item[i].field} ${item[i].operator.replaceAll('_', ' ')} ${item[i].value}` : null
                )
                .filter((item: any) => item)
                .join();
              return temp;
            }
          });
        }
        tempColumns.push(...criteriaColumns);
      }
      tempColumns.push({
        field: 'comments',
        headerName: 'Comment',
        minWidth: 240,
        flex: 1,
        renderCell: (params: any) => {
          return (
            <>
              {params.row.comments?.length > 1 ? (
                <Stack direction="column" spacing={0} className="fakeRowColSpan withLeftBorder">
                  {params.row.comments?.map((trial: any, index: any) => (
                    <Tooltip
                      key={`eligible_trials_${trial}`}
                      title={params.row.comments[index]?.length > 30 ? params.row.comments[index] : ''}
                      placement="top"
                    >
                      <Box className="tableCell">
                        <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                          {params.row.comments.length ? params.row.comments[index] : null}
                        </span>
                      </Box>
                    </Tooltip>
                  ))}
                </Stack>
              ) : params.row.comments.length ? (
                <Stack direction="column" spacing={0} className="fakeRowColSpan withLeftBorder">
                  <Box className="tableCell">{params.row.comments[0]}</Box>
                </Stack>
              ) : null}
            </>
          );
        },
        valueGetter: (params: any) => {
          return params.row.comments.join();
        }
      });
      setColumns(tempColumns);
    }
  }, [rows, data]);

  useEffect(() => {
    if (data?.selected_data.length > 0) {
      const temp = data?.selected_data.map((elem: any) => {
        return {
          id: elem.patient?.parent_id ? elem.patient?.parent_id : Math.random(),
          parent_id: elem.patient?.parent_id,
          Core_FICS_patient_identifier: elem.patient?.Core_FICS_patient_identifier,
          sex: elem.patient.sex,
          date_of_birth: moment(elem.patient.date_of_birth).format(`${userPreferedDateFormat.toUpperCase()}`),
          eligible_trials: elem.eligible_trials,
          comments: elem.comments.map((item: any) => item && Object.values(item)[0]),
          criteria: elem.criteria
        };
      });
      setRows(temp);
    } else {
      setRows([]);
    }
  }, [data, userPreferedDateFormat]);

  useEffect(() => {
    if (isError || updatePatientStatusIsError || updatePatientPreScreenStatusIsError) {
      if (isError) {
        setRows([]);
        setRowsCount(0);
      }
      const dataErorr: any = error || updatePatientStatusError || updatePatientPreScreenStatusError;
      if (dataErorr?.status == 500) {
        dispatch(
          setMessage({
            msgDetails: `${dataErorr?.status} : Internal Server Error`,
            severity: 'error'
          })
        );
      } else if (dataErorr?.status == 403) {
        dispatch(
          setMessage({
            msgDetails: 'Error 403 Restricted User permission',
            severity: 'error'
          })
        );
      }
    }
  }, [isError, updatePatientStatusIsError, updatePatientPreScreenStatusIsError]);

  React.useEffect(() => {
    if (updatePatientStatusLoading || updatePatientPreScreenStatusLoading) {
      dispatch(showLoader());
    } else {
      dispatch(hideLoader());
    }
  }, [updatePatientStatusLoading, updatePatientPreScreenStatusLoading]);

  const removePatient = (index: number) => {
    const preScreenPatients = [...selectedPreScreenFailPatients];
    preScreenPatients.splice(index, 1);
    setSelectedPreScreenFailPatients(preScreenPatients);
    if (preScreenPatients.length === 0) {
      handleClosePreScreen();
    }
  };

  const filterValues = (data: any) => {
    setFilterObject(data);
  };

  const dataTableProps = {
    getRowHeight: () => 'auto',
    sx: {
      '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': {
        py: '2px'
      },
      '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': {
        py: '8px'
      },
      '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': {
        py: '16px'
      }
    },
    initialState: {
      sorting: {
        sortModel: [{ field: 'Core_FICS_patient_identifier', sort: 'asc' }]
      }
    },
    filterMode: 'server'
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `Eligible Patients ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      <div style={{ display: 'flex', height: '100%' }}>
        <div style={{ flexGrow: 1 }}>
          <DataTable
            dataTableProps={dataTableProps}
            height="76vh"
            loading={isLoading}
            checkboxSelection
            selectionModel={selectionModel}
            onRowsSelection={onSelectionModelChange}
            CustomFooter={() => CustomFooterButtons(handleClickOpen, preScrnBtnEnable, handleClickPreScreen)}
            exportCSVName="Eligible Patients"
            paging
            pagination
            hasDefinedColumns
            columns={columns}
            pageSize={pageSize}
            setPageSize={setPageSize}
            rows={rows}
            setPageNumber={setPageNumber}
            rowsCount={rowsCount}
            page={pageNumber}
            paginationMode="server"
            filterValues={(data: any) => filterValues(data)}
            hasDefinedDataGridToolbarExport
            definedGridToolbarExport={definedCustomDatGridExport}
          />
        </div>
      </div>

      {/* {pop up to fail} */}
      <PopupComponent open={preScreenSubmit} onClose={() => setPreScreenSubmit(false)}>
        <DialogTitle>Please confirm Prescreen fail</DialogTitle>
        <DialogContent>Are you sure you want to fail the prescreen for the selected patients?</DialogContent>
        <DialogActions>
          <Button onClick={() => setPreScreenSubmit(false)} className="grey-btn">
            No
          </Button>
          <Button onClick={finalPreScreenSubmit} disabled={isLoaderLoading}>Yes</Button>
        </DialogActions>
      </PopupComponent>

      {/* Component Pre Screen Fail Patients*/}
      {/* Prescreen Dialog - Prescreen Fail*/}
      <PopupComponent open={preScreen} maxWidth="md">
        <Loader />
        <DialogTitle>Prescreen Fail</DialogTitle>
        <DialogContent className="tsda_prescreenDialog Fail">
          <TableContainer component={Paper} elevation={0} sx={{ maxHeight: '50vh', overflowY: 'auto' }}>
            <Table
              sx={{ minWidth: '100%' }}
              stickyHeader
              aria-label="Prescreen Fail List"
              className="tableWFontStyle SecColBold"
            >
              <TableHead>
                <TableRow>
                  <TableCell component="th">Core FICS Patient Identifier</TableCell>
                  <TableCell component="th">Study ID</TableCell>
                  <TableCell component="th">Comment</TableCell>
                  <TableCell component="th" />
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedPreScreenFailPatients.map((patient: any, index: number) => {
                  return (
                    <TableRow key={patient.id}>
                      <TableCell>{patient.patient_id}</TableCell>
                      <TableCell>{patient.trial_id}</TableCell>
                      <TableCell sx={{ paddingRight: 0 }}>
                        <TextField
                          id=""
                          label="Reason for Prescreen Fail"
                          multiline
                          fullWidth
                          required
                          maxRows={3}
                          variant="standard"
                          name="comment"
                          sx={{ mt: -1.75 }}
                          onChange={e => updateComment(e.target.value, index)}
                        />
                      </TableCell>
                      <TableCell align="right" sx={{ paddingLeft: 0 }}>
                        <IconButton>
                          <CloseIcon onClick={() => removePatient(index)} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePreScreen} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handlePreScreenSubmit} disabled={isLoaderLoading}>Confirm</Button>
        </DialogActions>
      </PopupComponent>

      {/* Prescreen Dialog - Add to Trail*/}
      <PopupComponent open={open} onClose={handleClose}>
        <Loader />
        <DialogTitle>Add to Trial</DialogTitle>
        <DialogContent className="tsda_prescreenDialog">
          <DialogContentText>
            <Alert severity="info">Prescreening IDs will be generated for each patient</Alert>
            <Typography mt={2} mb={1} sx={{ color: 'rgba(0,0,0,0.87)' }}>
              Patients to be added to trial:
            </Typography>
          </DialogContentText>

          <Paper sx={{ width: '100%', height: '196px', bgcolor: 'background.paper', overflowY: 'auto', mb: 2 }}>
            <List dense component="nav">
              {selectedIds.map((id: any, i: number) => (
                <ListItem key={i} disablePadding>
                  <ListItemText primary={id} sx={{ padding: '5px', paddingLeft: '13px' }} />
                </ListItem>
              ))}
            </List>
          </Paper>

          <FormControl fullWidth>
            <InputLabel id="select-Trial">Trial</InputLabel>
            <Select
              labelId="select-Trial"
              id="select-Trail-number"
              size="small"
              variant="standard"
              value={trial}
              label="Trial"
              onChange={handleChange}
            >
              {eligibaleTrialIds.length > 0 &&
                eligibaleTrialIds.map((item: any) => (
                  <MenuItem value={item} key={item}>
                    {item}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} className="grey-btn">
            Cancel
          </Button>
          <Button onClick={handleConfirm} disabled={disableconfirm}>
            Confirm
          </Button>
        </DialogActions>
      </PopupComponent>
    </div>
  );
}
